export default {
	/**
	 * Determine if a row is blank.
	 *
	 * @param object row
	 *
	 * @return bool
	 */
	isBlankRow(row) {
		if (row && ! row.baume && ! row.temp && ! row.comments && this.isEmptyAction(row) && this.isEmptyAnalysis(row)) {
			return true;
		}

		return false;
	},

	isEmptyAction(row) {
		if ($.isEmptyObject(row.action)) {
			return true;
		}

		if (row.action.data) {
			let data = row.action.data;

			if (data.aeration || data.pump_over || data.dap || data.juice || data.reinoculate || data.water || parseFloat(data.agitator) > 0) {
				return false;
			}
		}

		return true;
	},

	isEmptyAnalysis(row) {
		if ($.isEmptyObject(row.analysis)) {
			return true;
		}

		if (row.analysis.data) {
			let data = row.analysis.data;

			if (
				data.cell_count ||
				data.fs02 ||
				data.gf ||
				data.ntu ||
				data.ph ||
				data.ta ||
				data.ts02 ||
				data.alcohol ||
				data.malic_acid ||
				(this.simulatorSetup.secondary_sugar_units == 'sg' && data.rs) ||
				(this.simulatorSetup.secondary_sugar_units == 'rs' && data.sg)
			) {
				return false;
			}
		}

		return true;
	}
}



// WEBPACK FOOTER //
// ./src/components/ferment/daily-data/row-helpers.js